module.exports = __webpack_public_path__ + "img/serviceImg4.279a5d54.gif";